export default __webpack_public_path__ + "static/media/user-fill-1.91e4fa74.svg";